import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_IOS_MOBILE, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

export const helpAutoUploadHref = getFeature('autoupload-promo-help') || 'https://help.mail.ru/cloud_web/files/unlimited/';

// CLOUDWEB-18688
// [Безлимитная автозагрузка] Промо
const autoUploadPromoWeb: boolean | undefined = !IS_WEBVIEW && isFeature('autoupload-promo');
const autoUploadPromoWebviewIos: boolean | undefined = IS_WEBVIEW && isFeature('autoupload-promo-ios');
const autoUploadPromoWebviewAndroid: boolean | undefined = IS_WEBVIEW && isFeature('autoupload-promo-android');

const autoUploadPromoWebview: boolean | undefined = IS_IOS_MOBILE ? autoUploadPromoWebviewIos : autoUploadPromoWebviewAndroid;

export const autoUploadPromo = autoUploadPromoWeb || autoUploadPromoWebview;

// CLOUDWEB-18689
// [Безлимитная автозагрузка] Сабс: отток
const autoUploadUnsubsWeb: boolean | undefined = !IS_WEBVIEW && isFeature('autoupload-unsubs');
const autoUploadUnsubsWebviewIos: boolean | undefined = IS_WEBVIEW && isFeature('autoupload-unsubs-ios');
const autoUploadUnsubsWebviewAndroid: boolean | undefined = IS_WEBVIEW && isFeature('autoupload-unsubs-android');

const autoUploadUnsubsWebview: boolean | undefined = IS_IOS_MOBILE ? autoUploadUnsubsWebviewIos : autoUploadUnsubsWebviewAndroid;

export const autoUploadUnsubs = autoUploadUnsubsWeb || autoUploadUnsubsWebview;

// CLOUDWEB-18688
// [Безлимитная автозагрузка] Промо
const autoUploadInfoBlockWeb: boolean | undefined = !IS_WEBVIEW && isFeature('autoupload-info-block');
const autoUploadInfoBlockWebviewIos: boolean | undefined = IS_WEBVIEW && isFeature('autoupload-info-block-ios');
const autoUploadInfoBlockWebviewAndroid: boolean | undefined = IS_WEBVIEW && isFeature('autoupload-info-block-android');

const autoUploadInfoBlockWebview: boolean | undefined = IS_IOS_MOBILE ? autoUploadInfoBlockWebviewIos : autoUploadInfoBlockWebviewAndroid;

export const autoUploadInfoBlock = autoUploadInfoBlockWeb || autoUploadInfoBlockWebview;

// tempexp_18926-start
const autoUploadOnboardingValue: 'a' | 'b' | 'c' | 'd' | undefined = getFeature('autoupload-onboarding');
export const autoUploadOnboarding = !IS_WEBVIEW && autoUploadOnboardingValue !== 'a' ? autoUploadOnboardingValue : false;

if (!IS_WEBVIEW) {
    registerExperiment(
        'autoupload-onboarding',
        autoUploadOnboardingValue,
        [
            AnalyticEventNames.AUTOUPLOAD_ONBOARDING_SHOW,
            AnalyticEventNames.AUTOUPLOAD_ONBOARDING_CLICK,
            AnalyticEventNames.AUTOUPLOAD_ONBOARDING_FINAL_SHOW,
            AnalyticEventNames.AUTOUPLOAD_ONBOARDING_FINAL_CLICK,
            AnalyticEventNames.QUOTA_LANDING_SHOWN,
            AnalyticEventNames.MOBILE_LANDING_SHOWN,
            AnalyticEventNames.TARIFF_CLICK,
            AnalyticEventNames.FAST_CHECKOUT_SHOWN,
            AnalyticEventNames.TARIFF_BUY,
        ],
        {
            sendXrayArgs: {
                [AnalyticEventNames.FAST_CHECKOUT_SHOWN]: ({ paySource }, { eventName }) => {
                    let name = eventName;

                    if (paySource?.startsWith('autoload_1tb')) {
                        name = 'step1-show';
                    } else if (paySource?.startsWith('autoload_1tb_v2')) {
                        name = 'step2-show';
                    }

                    return {
                        eventName: name,
                    };
                },
                [AnalyticEventNames.TARIFF_BUY]: ({ paySource }, { eventName }) => {
                    let name = eventName;

                    if (paySource?.startsWith('autoload_1tb')) {
                        name = 'step1-buy';
                    } else if (paySource?.startsWith('autoload_1tb_v2')) {
                        name = 'step2-buy';
                    }

                    return {
                        eventName: name,
                    };
                },
            },
        }
    );
}

const autoUploadUnsubsStep2Value: 'a' | 'b' | undefined = getFeature('autoupload-unsubs-step-2');
export const autoUploadUnsubsStep2 = autoUploadUnsubsStep2Value === 'b';

registerExperiment('autoupload-unsubs-step-2', autoUploadUnsubsStep2Value, [
    AnalyticEventNames.AUTOUPLOAD_CANCEL_SHOW,
    AnalyticEventNames.AUTOUPLOAD_CANCEL_SAVE,
    AnalyticEventNames.AUTOUPLOAD_CANCEL,
]);
// tempexp_18926-end

export const AUTOUPLOAD_SHORT_FEATURE_TEXT = 'Безлимит для фото с телефона';
export const autouploadPromoBlockIOS = isFeature('autoupload-promo-block-ios');
export const autouploadPromoBlockAndroid = isFeature('autoupload-promo-block-android');
export const autouploadPromoBlockMobile = isFeature('autoupload-promo-block-mobile');
export const autouploadPromoBlockWebview = IS_IOS_MOBILE ? autouploadPromoBlockIOS : autouploadPromoBlockAndroid;
export const autouploadPromoBlockMobileEnabled = autoUploadPromo && (IS_WEBVIEW ? autouploadPromoBlockWebview : autouploadPromoBlockMobile);
